import React, { Component } from "react";
import { connect } from "react-redux";
import xss from "xss";

import { Link, useMatch, useNavigate } from "../utils/components/router";
import { pageActions } from "../actions";
import Messages from "./Messages";
import { backToShopOnError } from "../utils/enums/CONSTANTS";
import { console } from "../utils/functions";
import { BeendenButton } from "../utils/components";

class ErrorPage extends Component {
  constructor(props) {
    super(props);
    this.resetPageStorage = this.resetPageStorage.bind(this);
    this.refreshHomePage = this.refreshHomePage.bind(this);
  }
  resetPageStorage() {
    if (typeof this.props.onResetError === "function") {
      this.props.onResetError();
    } else if (typeof this.setState === "function") {
      this.setState({ error: false, initialized: false, loaded: false });
    }
  }

  refreshHomePage() {
    this.props.dispatch(pageActions.refresh());
  }

  renderDeltaError() {
    const errorMessage = this.props.pageStorage.message || "Preise haben sich geändert";
    return (
      <div className="if6_outer section if6_section">
        <div className="if6_inner bootstrap-iso">
          <div className="">
            <div className="container bg-white p-one">
              <p>
                Entschuldigung, die Überprüfung des Warenkorbs ist fehlgeschlagen.
                <br />
                {errorMessage}
                <br />
                Bitte versuchen Sie es noch einmal.
                <br />
                <Link
                  to={this.props.configStorage.getBackToShopLink()}
                  className="btn btn-info col-12 col-md-6 col-lg-2"
                  onClick={this.refreshHomePage}
                >
                  {backToShopOnError}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderError() {
    let errorMessage = this.props.errorMsg
      ? this.props.errorMsg
      : this.props.messageStorage.errorMsg;
    if (this.props.pageStorage.message && this.props.pageStorage.message !== errorMessage)
      errorMessage = this.props.pageStorage.message + errorMessage;
    if (this.props.messageText || this.props.messageTitle) {
      return (
        <div>
          <div className="bootstrap-iso ">
            <div className="container pt-one pb-two bg-white">
              <Messages
                message={this.props.messageTitle}
                messageText={this.props.messageText}
                type="error"
              />
              <div className="col-12 col-lg-12 mb-three mt-one d-sm-flex d-md-flex justify-content-between">
                { !(this.props.configStorage.isDeuBa() && this.props.rightStorage.isEmpty()) ?
                  (<Link
                    to={this.props.configStorage.getBackToLandingPageLink()}
                    className="btn btn-info col-12 col-md-4 col-lg-2"
                    onClick={this.resetPageStorage}
                  >
                    Zurück zum Shop
                  </Link>) : null
                }
                <BeendenButton />
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <p>Entschuldigung, es ist ein Fehler aufgetreten.</p>
        <p>Fehlermeldung: {xss(errorMessage)}</p>
        <p>Bitte versuchen Sie es später erneut.</p>
        <p>
          {this.props.configStorage.isVerseNeo()
            ? <a
              href={this.props.configStorage.getBackToLandingPageLink()}
              className="btn btn-info col-12 col-md-6 col-lg-2"
            >
              Zurück zur Startseite
            </a>
            : (!(this.props.configStorage.isDeuBa() && this.props.rightStorage.isEmpty()) ?
            (<a
              href={this.props.configStorage.getBackToShopLink()}
              className="btn btn-info col-6 col-md-4 col-lg-2"
              onClick={this.resetPageStorage}
            >
              Zurück zum Shop
            </a>) : null
            )
          }
          <BeendenButton />
        </p>
      </div>
    );
  }

  render() {
    // no error set
    if (this.props.pageStorage.isDeltaErrorPage()) {
      return this.renderDeltaError();
    }
    if (
      !this.props.errorMsg &&
      !this.props.messageStorage.errorMsg &&
      !this.props.messageText &&
      !this.props.messageTitle &&
      !this.props.pageStorage.isErrorPage() &&
      this.props.messageStorage.text
    ) {
      return <div className="alert alert-danger">{xss(this.props.messageStorage.text)}</div>;
    }
    if (
      !this.props.errorMsg &&
      !this.props.messageStorage.errorMsg &&
      !this.props.messageText &&
      !this.props.messageTitle &&
      !this.props.pageStorage.isErrorPage()
    ) {
      console.debug(this.props)
      return <div className="alert alert-danger">Unbekannter Fehler</div>;
    }

    console.log("ErrorPage", this.props);
    return (
      <div className="if6_outer section if6_section">
        <div className="if6_inner bootstrap-iso">{this.renderError()}</div>
      </div>
    );
  }
}

export default connect((store) => {
  return {
    messageStorage: store.messageStorage,
    configStorage: store.configStorage,
    rightStorage: store.rightStorage,
    pageStorage: store.pageStorage,
  };
})((props) => {
  const { error } = useMatch();
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  const state = props.configStorage.getContextNavigateState();
  return <ErrorPage {...props} error={error} navigate={contextNavigate} {...state} />;
});
